import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rabatt',
  templateUrl: './rabatt.component.html',
  styleUrls: ['./rabatt.component.scss']
})
export class RabattComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
